module.exports = __webpack_public_path__ + "img/s3-5.3d47e2ce.jpg";